<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 5.25V4.5C20.2483 3.9038 20.0107 3.3325 19.5891 2.91092C19.1675 2.48934 18.5962 2.25173 18 2.25H3C2.4038 2.25173 1.8325 2.48934 1.41092 2.91092C0.98934 3.3325 0.751731 3.9038 0.75 4.5V16.5C0.751731 17.0962 0.98934 17.6675 1.41092 18.0891C1.8325 18.5107 2.4038 18.7483 3 18.75H3.75"
      :stroke="fillColor"
      stroke-linejoin="round"
    />
    <path
      d="M21.0942 6H6.65578C5.46518 6 4.5 6.96518 4.5 8.15578V19.5942C4.5 20.7848 5.46518 21.75 6.65578 21.75H21.0942C22.2848 21.75 23.25 20.7848 23.25 19.5942V8.15578C23.25 6.96518 22.2848 6 21.0942 6Z"
      :stroke="fillColor"
      stroke-linejoin="round"
    />
    <path
      d="M17.4804 11.7278C18.277 11.7278 18.9228 11.0867 18.9228 10.2958C18.9228 9.50491 18.277 8.86377 17.4804 8.86377C16.6838 8.86377 16.0381 9.50491 16.0381 10.2958C16.0381 11.0867 16.6838 11.7278 17.4804 11.7278Z"
      :stroke="fillColor"
      stroke-miterlimit="10"
    />
    <path
      d="M16.0383 17.4453L11.9531 13.3958C11.692 13.1378 11.3427 12.9884 10.9757 12.9779C10.6087 12.9674 10.2514 13.0964 9.97594 13.3391L4.5 18.1705"
      :stroke="fillColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.4326 21.7501L17.9915 16.2315C18.2473 15.9792 18.5875 15.8307 18.9464 15.8145C19.3053 15.7983 19.6575 15.9156 19.935 16.1438L23.25 18.8865"
      :stroke="fillColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "PictureSVG",
  props: {
    fillColor: {
      type: String,
      default: "#26262C",
    },
  },
};
</script>
